import React, { useEffect, useState } from 'react'
import NeedHelp from '../../../Common/NeedHelp/NeedHelp';
import { Card, Button, Row, Col, Modal, Spin } from 'antd';
import './multistepform.scss'
import styled from 'styled-components';
import usecustomStyles from '../../../Common/customStyles';
import OtpVerification from '../../Components/FormSteps/OtpVerification';
import prevButton from '../../../../src/assets/images/prev-button.png'
import AboutBusiness from '../../Components/FormSteps/AboutBusiness';
import { useSelector, useDispatch } from 'react-redux';
import { api } from '../../../helpers/api_helper';
import { businessInfo } from '../../../slices/businessInfo/thunk';
import { useNavigate } from 'react-router-dom';
import { setAuthData } from '../../../helpers/localstorage/setAuthData';
import { requestOtp } from '../../../slices/auth/login/thunk';
import { Popup_Toast } from '../../../constants/Popups_Toast';
import { API_ENDPOINTS } from '../../../constants/apiEndPoints';

const StyleWrapper = styled.div`
    background-color: ${({ theme }) => theme.token.authbgcolor};
`

const MultiStepFormData = React.createContext();
const customStyles = usecustomStyles();

const FORM_STEPS = [
    {
        "title": "OTP Verification",
        "content": ""
    },
    {
        "title": "Tell us more about your Bureau",
        // "content": "These details will be visible to users on your listing. "
    },
];

const MultiStepForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const popupData = Popup_Toast?.MULTI_STEP_FORM?.BACK_ONBOARDING;

    const current = useSelector(state => state.Login);
    const info = useSelector((state) => state.BusinessInfoReducer);
    const loginData = useSelector(state => state.Login);
    // const businessInfoDetails = useSelector(state => state.BusinessInfoReducer.businessInfo);

    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [resentOtpTriggered, setRecentOtpTriggered] = useState(false);
    const [currentPageStatus, setCurrentPageStatus] = useState();
    const [skipButtonVisible, setSkipButtonVisible] = useState(true);
    const [resetForm, setResetForm] = useState(false);
    const [formVerified, setFormVerified] = useState([false, false]);
    const [formData, setFormData] = useState({
        otp: "",
        name: "",
        contact_number: "",
        address: ""
    });
    const [errorModal, setErrorModal] = useState({
        status: false,
        message: ""
    });
    const [unsavedProgressModal, setUnsavedProgressModal] = useState(false);
    // const [gstDataModal, setGstDataModal] = useState(false);

    const pageLength = FORM_STEPS.length;
    const progress = 100 / pageLength;

    // const getCategories = (categoriesList) => {
    //     setPassedCategoriesList(categoriesList);
    // };

    const verifyOtp = async (otp) => {
        setLoading(true);
        try {
            const response = await api.create(`${API_ENDPOINTS.AUTH.VERIFY_OTP}`, {
                phone: current.user.phoneNumber,
                country_code: '+91',
                otp: loginData?.user?.otp || otp
            });

            if (response?.success && response?.data?.access_token) {
                // Transform the response to match setAuthData expected structure
                const authData = {
                    accessToken: response.data.access_token,
                    user: response.data.user,
                    refreshToken: '', // Not provided in this response
                    profile_completion: 1 // Set to 1 after OTP verification
                };

                setAuthData(authData);

                // Check if profile is already completed
                if (response?.data?.user?.profile_completed === true) {
                    // Profile is completed, navigate directly to dashboard
                    navigate('/dashboard');
                } else {
                    // Profile not completed, go to next page
                    setPage(1);
                }

                setLoading(false);
            } else {
                setLoading(false);
                setErrorModal(prev => ({
                    ...prev,
                    status: true,
                    message: response?.message || 'OTP verification failed'
                }));
            }
        } catch (err) {
            console.error('catch error is showing', err);
            setLoading(false);
            const errorMessage = typeof err === 'string' ? err : (err?.message || 'An error occurred during OTP verification');
            setErrorModal(prev => ({
                ...prev,
                status: true,
                message: errorMessage
            }));
        }
    };


    const updateBusinessInfo = async (info) => {
        try {
            setLoading(true);
            const data = await api.create(`${API_ENDPOINTS.BUSINESS_INFO.CREATE}`, info);
            if (data) {
                setLoading(false);
                dispatch(businessInfo());
                navigate('/dashboard');
            }
        } catch (err) {
            setLoading(false);
            setErrorModal(prev => ({
                ...prev,
                status: true,
                message: err?.message || 'An error occurred while updating business info'
            }));
        }
    };

    const resendFunctionality = async (clicked) => {
        setLoading(true);
        try {
            // Use phone number from formData (which comes from localStorage) instead of Redux state
            const phoneNumber = formData.contact_number || current.user.phoneNumber;
            await dispatch(requestOtp(phoneNumber)).unwrap();
            setLoading(false);
            setRecentOtpTriggered(true);
        } catch (error) {
            setLoading(false);
            alert(error.message || 'An error occurred while requesting OTP');
            setRecentOtpTriggered(false);
        }
    };

    const handleContinueClick = (e) => {
        if (page === 0 && formData.otp.length === 6) {
            verifyOtp(formData.otp);
        } else if (page === 1 && Array.isArray(formVerified) && formVerified[page]) {
            const { otp, phone, ...payload } = formData;
            updateBusinessInfo(payload);
        } else {
            e.preventDefault();
            return false;
        }
    };

    const getTitle = () => FORM_STEPS[page]?.title;
    const getContent = () => FORM_STEPS[page]?.content;

    const renderFormStep = () => {
        switch (page) {
            case 0:
                return <OtpVerification resendClick={resendFunctionality} resentOtpTriggered={resentOtpTriggered} />;
            case 1:
                return <AboutBusiness />;
            default:
                return <OtpVerification />;
        }
    };

    useEffect(() => {
        let pageStatus = currentPageStatus + 1;
        if (currentPageStatus >= 1) {
            if (currentPageStatus >= 2) {
                // If profile completion is 2 or more, navigate to dashboard
                navigate('/dashboard');
                return;
            }
            setPage(pageStatus);
        } else if (currentPageStatus === 0) {
            setPage(1);
        }
    }, [currentPageStatus, navigate]);

    // useEffect(() => {
    //     if (localStorage.getItem('accessToken') && page !== 0) {
    //         dispatch(businessInfo());
    //     }
    // }, [otpVerified, dispatch, page]);

    // Initialize form verification state
    useEffect(() => {
        if (!Array.isArray(formVerified) || formVerified.length < 2) {
            setFormVerified([false, false]);
        }
    }, []);

    // Populate phone number on OTP page from localStorage (persist across reloads)
    useEffect(() => {
        if (page === 0) {
            const savedPhoneNumber = localStorage.getItem('phone');
            if (savedPhoneNumber) {
                setFormData(prev => ({
                    ...prev,
                    contact_number: savedPhoneNumber
                }));
            }
        }
    }, [page]);

    // Remove phone number from storage when leaving OTP page
    useEffect(() => {
        if (page !== 0) {
            localStorage.removeItem('phone');
        }
    }, [page]);

    // Removed effect that continuously reset formVerified[0] on page 0,
    // which caused an infinite render loop and blocked OTP progress.

    // Redirect to login if OTP page is reloaded without phone number
    useEffect(() => {
        if (page === 0) {
            const savedPhoneNumber = localStorage.getItem('phone');
            const reduxPhoneNumber = current?.user?.phoneNumber;

            // If no phone number in localStorage or Redux, redirect to login
            if (!savedPhoneNumber && !reduxPhoneNumber) {
                navigate('/login');
            }
        }
    }, [page, current?.user?.phoneNumber, navigate]);

    useEffect(() => {
        if (info && page >= 1) {
            setCurrentPageStatus(info?.businessInfo?.profile_completion);
        }
    }, [info, page]);

    useEffect(() => {
        if (resentOtpTriggered) {
            setTimeout(() => {
                setRecentOtpTriggered(false);
            }, 5000);
        }
    }, [resentOtpTriggered]);


    return (
        <>
            <figure className="bg_wrapper">
                <img src="" alt="" />
            </figure>
            <StyleWrapper>
                <Row justify="center" align="middle" style={{ minHeight: '100vh' }}>
                    <Col xs={22} lg={14}>
                        <Card style={{ width: "100%" }} className='parent_radius multi_step_form'>
                            <Button
                                htmlType="submit"
                                type='dashed'
                                className='prev_button border_unset'
                                onClick={() => {
                                    if (page === 0) {
                                        window.location.href = '/login';
                                    } else {
                                        setUnsavedProgressModal(true);
                                    }
                                }}
                                style={{
                                    width: "auto",
                                    background: "transparent",
                                    boxShadow: 'unset',
                                    marginTop: "calc(2vw + 20px)",
                                    marginLeft: "calc(1vw + 20px)"
                                }}
                            >
                                <img src={prevButton} alt="" />
                            </Button>

                            <div className="progress">
                                <span style={{ width: `${((page + 1) * progress)}%` }}></span>
                            </div>

                            <Row gutter={[16, 24]} className='form_wrap' style={{ flexDirection: "column", position: 'relative' }}>
                                <div className="multistep_form_content">
                                    <div className="text-center" style={{ margin: "20px 0" }}>
                                        <h2 className='text_lg' style={{ color: customStyles.colorPrimary }}>{getTitle()}</h2>
                                        <p className='sm2'>{getContent()}</p>
                                    </div>
                                    <div>
                                        <MultiStepFormData.Provider value={{
                                            formData,
                                            setFormData,
                                            formVerified,
                                            setFormVerified,
                                            page,
                                            reset: resetForm,
                                            setReset: setResetForm,
                                            skipButtonVisible,
                                            setSkipButtonVisible
                                        }}>
                                            {renderFormStep()}
                                        </MultiStepFormData.Provider>
                                    </div>
                                </div>

                                {loading && (
                                    <div className="spinner sm center">
                                        <Spin />
                                    </div>
                                )}

                                <div className='text-center button_holder'>
                                    <Button
                                        htmlType="submit"
                                        type='primary'
                                        className='md'
                                        disabled={!formVerified[page]}
                                        onClick={handleContinueClick}
                                        style={{
                                            width: "100%",
                                            maxWidth: "calc(200px + 6.5vw)",
                                            marginLeft: "auto",
                                            marginRight: "auto",
                                            marginTop: "0",
                                            height: "auto"
                                        }}
                                    >
                                        Continue
                                    </Button>
                                </div>
                            </Row>
                        </Card>
                    </Col>
                </Row>

                <Modal
                    className='sm_modal work_modal center_modal otp_modal'
                    open={errorModal.status}
                    onCancel={() => setErrorModal({ status: false, message: '' })}
                    footer={[
                        <div className='text-center'>
                            <Button
                                key="ok"
                                type="primary"
                                className='short wide'
                                onClick={() => setErrorModal({ status: false, message: '' })}
                            >
                                Ok
                            </Button>
                        </div>
                    ]}
                >
                    <div className="modal_cnt">
                        <h2 className="text_lg text_red">OTP verification failed</h2>
                        <p className="md">{errorModal.message}</p>
                    </div>
                </Modal>

                <Modal
                    className='sm_modal work_modal center_modal discard_modal'
                    open={unsavedProgressModal}
                    closable={false}
                    footer={[
                        <div className='text-center'>
                            <Button
                                key="stay"
                                type="primary"
                                className='short wide'
                                onClick={() => {
                                    window.location.href = '/login';
                                }}>
                                Continue
                            </Button>
                            <Button
                                key="close"
                                type="text"
                                className="short custom_btn"
                                onClick={() => setUnsavedProgressModal(false)}
                            >
                                Close
                            </Button>
                        </div>
                    ]}
                    onCancel={() => setUnsavedProgressModal(false)}
                >
                    <div className="modal_cnt">
                        <h2 className="text_lg text_red">{popupData?.content?.title}</h2>
                        <p className="md">{popupData?.content?.description}</p>
                    </div>
                </Modal>

                <NeedHelp />
            </StyleWrapper>
        </>
    );
};

export default MultiStepForm;
export { MultiStepFormData };
